class ApiUtil {
    /**
     * @param options.omitContentType When true, Content-Type is omitted (use for FormData so the runtime sets multipart boundary).
     * Existing call sites omit `options` and keep `application/json`.
     */
    DefaultHeaders(token?: string, options?: { omitContentType?: boolean }) {
        const includeJsonContentType = !options?.omitContentType;
        const jsonContentHeaders = (): Record<string, string> =>
            includeJsonContentType ? { 'Content-Type': 'application/json' } : {};

        if (token) {
            return {
                headers: {
                    ...jsonContentHeaders(),
                    'Authorization': `Bearer ${token}`
                }
            }
        }
        else {
            let persistedStorage = localStorage.getItem('persist:root');

            let authReducer;
    
            if (persistedStorage) {
                let persistedStorageObject = JSON.parse(persistedStorage);
                authReducer = JSON.parse(persistedStorageObject.authReducer);
            }
    
            if (authReducer) {
                if (authReducer.subscribedToken) {
                    return {
                        headers: {
                            ...jsonContentHeaders(),
                            'Authorization': `Bearer ${authReducer.subscribedToken}`
                        }
                    }
                }
                return null;
            }
        }
        
        return {
            headers: {
                ...jsonContentHeaders()
            }
        }
    }

    GetModuleId() {
        let persistedStorage = localStorage.getItem('persist:root');

        let brandingReducer;

        if (persistedStorage) {
            let persistedStorageObject = JSON.parse(persistedStorage);
            brandingReducer = JSON.parse(persistedStorageObject.brandingReducer);
        }

        if (brandingReducer) {
            return brandingReducer.moduleId;
        }
        
        return 0;
    }

    GetRefreshToken() {
        let persistedStorage = localStorage.getItem('persist:root');

        let authReducer;

        if (persistedStorage) {
            let persistedStorageObject = JSON.parse(persistedStorage);
            authReducer = JSON.parse(persistedStorageObject.authReducer);
        }

        if (authReducer && authReducer.refreshToken) {
            return { "RefreshToken": authReducer.refreshToken };
        }
        
        return null;
    }
}

export default ApiUtil; 